import { directDownload } from "@/utils/download-helper";
import Axios from "axios";
import { ActionTree } from "vuex";
import { RootState } from "../../types";
import { PartnerUserItem, PartnerUserFilter, PartnerUsersState } from "./types";

export const actions: ActionTree<PartnerUsersState, RootState> = {
  getPartnerUsers: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Axios({ url: "/acapi/partner_users", params: data })
        .then((resp) => {
          if (data?.page_number > 1) {
            commit("pushPartnerUsers", resp.data.partner_users);
          } else {
            commit('setPartnerUsers', resp.data.partner_users);
          }
          resolve(resp.data.partner_users);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  getPartnerUserItem: ({ commit }, id) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({ url: `/acapi/partner_users/${id}` })
        .then((resp: any) => {
          let partnerUserItem = <PartnerUserItem>resp.data;
          partnerUserItem.id = id;
          commit("setPartnerUserItem", partnerUserItem);
          resolve(partnerUserItem);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  savePartnerUserItem: ({ commit, dispatch }, data: PartnerUserItem) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      if (data.role_id){
        delete data.partner_user_page_blocks
      }else {
        data.partner_user_page_blocks
         ?.filter((value) => !value.allowed)
         .map((value) => {
           if (value.id === 1 || value.id === 2){
             value.allowed = 1;
           } else {
             value.allowed = 0;
           }
          });
      }
      Axios({
        method: data.id ? "put" : "post",
        url: "/acapi/partner_users/" + (data.id ?? ""),
        data: data,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  deletePartnerUserItem: ({ commit, dispatch }, data: PartnerUserItem) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({
        method: "delete",
        url: `/acapi/partner_users/${data.id}`,
        data: data,
      })
        .then((resp: any) => {
          dispatch("getPartnerUsers");
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  resetPassword: ({ commit, dispatch }, data: any) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({
        method: "post",
        url: `/acapi/partner_users/password_link`,
        data: data,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportPartnerUsers({}, data: PartnerUserFilter) {
    return directDownload("/acapi/partner_users/export", data);
  },
};
